module.exports = __webpack_public_path__ + "static/media/61.9888fbaf.jpg";